import { render, staticRenderFns } from "./rentControlChart.vue?vue&type=template&id=01d5ea86&scoped=true"
import script from "./rentControlChart.vue?vue&type=script&lang=js"
export * from "./rentControlChart.vue?vue&type=script&lang=js"
import style0 from "./rentControlChart.vue?vue&type=style&index=0&id=01d5ea86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d5ea86",
  null
  
)

export default component.exports